module.exports = __webpack_public_path__ + "img/hotels-2.2554909d.png";